import styled from 'styled-components';
import { vw } from 'components/common/Common';

const CommissionSection = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
`;

const CommissionTitle = styled.h2`
  font-size: 40px;
  font-weight: 600;
  color: #050a30;
`;

const TiersContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  gap: ${vw(24)};
  align-items: stretch;
`;

const TierCard = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  padding: ${vw(32)} 0;
  gap: 16px;
`;

const TierTitle = styled.div`
  font-size: 48px;
  font-weight: 600;
  color: #3574e3;
  line-height: normal;
`;

const TierDetail = styled.div`
  font-size: 16px;
  font-weight: 400;
  line-height: 1.3;
  color: #3574e3;
`;

const commissionTiers = [
  {
    title: 'Standard',
    details: [
      '1 or fewer deals per month',
      '10% Commission Rate (of Net Profit)',
      'Example Payout on $10,000 Profit: $1,000',
    ],
  },
  {
    title: 'Premium',
    details: [
      '2-4 deals per month',
      '20% Commission Rate (of Net Profit)',
      'Example Payout on $10,000 Profit: $2,000',
    ],
  },
  {
    title: 'Elite',
    details: [
      '5+ deals per month',
      '30% Commission Rate (of Net Profit)',
      'Example Payout on $10,000 Profit: $3,000',
    ],
  },
];

const Commission = () => {
  return (
    <CommissionSection>
      <CommissionTitle>New Commission Tiers</CommissionTitle>
      <TiersContainer>
        {commissionTiers.map((tier, index) => (
          <TierCard key={index}>
            <TierTitle>{tier.title}</TierTitle>
            <div>
              {tier.details.map((detail, idx) => (
                <TierDetail key={idx}>{detail}</TierDetail>
              ))}
            </div>
          </TierCard>
        ))}
      </TiersContainer>
    </CommissionSection>
  );
};

export default Commission;
